import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { DownLoadFileService } from "~app/services/download-file.service";
import { environment } from "~env";

const PROJ_API_URL = environment.registrarCommandApi;

@Injectable({
  providedIn: 'root',
})
export class PublicMemberSearchCommandService {

  constructor(private http: HttpClient, private downLoadFileService: DownLoadFileService,) { }

  authorizeDocumentDownload(decisionId: string, documentId: string, fileName: string): Observable<string> {
    return this.http.post<any>(`${PROJ_API_URL}/PublicMemberInfos/${decisionId}/document/${documentId}/authorize-download`, {})
      .pipe(
        switchMap((res: { location: string }) => this.downLoadFileService.downloadFile(res.location, fileName)),
      );
  }
}